class SectionMainArticle
{
  init()
  {
    this.initSplide();
    this.handleComments();
  }

  handleComments()
  {
    const comments = document.querySelectorAll('.article-template__comments-comment');

    if (!comments.length) {
      return;
    }

    // Loop through comments to find comments from "FRAU BLUM" that actually respond to a specific customer
    comments.forEach(function(comment, index) {
      if (comment.querySelector('.caption-with-letter-spacing').innerText !== "FRAU BLUM") {
        return;
      }

      const paragraph = comment.querySelector('p');
      const text = paragraph.innerText;
      const matches = text.match(/^@(.*?):/);

      if (!matches) {
        return;
      }

      const targetName = matches[1];

      // Loop again through comments to find first target that has not been marked as already edited
      let processed = false;
      comments.forEach(function(innerComment) {
        if (processed) {
          return;
        }

        if (innerComment.dataset.processed) {
          return;
        }
      
        if (innerComment.querySelector('.caption-with-letter-spacing').innerText !== targetName.toUpperCase()) {
          return;
        }

        comment.remove();
        innerComment.insertAdjacentElement('afterend', comment);

        comment.style.marginLeft = '10rem';
        paragraph.style.fontStyle = 'italic';
        paragraph.innerText = text.replace('@' + targetName + ':', '').trim();
        innerComment.dataset.processed = '1';
        
        processed = true;
      });
    });
    
  }

  initSplide()
  {
    const splideSections = document.querySelectorAll('.splide');

    if (!splideSections.length) {
      return;
    }
    
    new Splide('.splide', {
      type: 'loop'
    }).mount();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const section = new SectionMainArticle();
  section.init();
});